import React from 'react'

export const FieldGroupPlaceholder = () => (
  <div className='mx-auto h-40 flex items-center '>
    Fügen Sie über das Auswahlmenü Felder hinzu
  </div>
)
